import CommunityBody from './CommunityBody';

export default function CommunityBodyWrapper(props) {
  const { data, primaryCategory, stage } = props;
  return (
    <div>
      <CommunityBody
        data={data}
        primaryCategory={primaryCategory}
        stage={stage}
      />
    </div>
  );
}
